import { useTranslation } from "@repo/i18n";
import { ShellFrame } from "../shell/ShellFrame";
import { ErrorState } from "../shell/states";

/**
 * Per-route error fallback: a render/loader error in the booking route shows a self-contained error
 * frame inside the widget chrome instead of taking the whole iframe down to a blank. No analytics
 * dependency here (the widget is diner-weight and egresses only to the API); the frame stays useful.
 */
export function RouteErrorBoundary() {
  // Touch the translation hook so the boundary participates in the active language.
  useTranslation();
  return (
    <ShellFrame>
      <ErrorState onRetry={() => window.location.reload()} />
    </ShellFrame>
  );
}
